<template>
    <ViewCommandeFournisseur />
</template>

<script lang="ts">
    import ViewCommandeFournisseur from "@/components/GesCom/CommandeFournisseur/ViewCommandeFournisseur.vue";
    import { defineComponent } from "vue";

    export default defineComponent({
        name: "ViewCommandeFournisseurPage",
        components: {
            ViewCommandeFournisseur,
        },
    });
</script>